
import { createApp } from 'vue'
import App from './App.vue'
import './style/index.css'
import router from './router'
import 'vant/lib/index.css';
import { Swipe, SwipeItem } from 'vant';
import { Col, Row } from 'vant';
import { Loading } from 'vant';
import { Icon } from 'vant';
import { Slider } from 'vant';
import { captureStoreCodeFromUrl } from './utils/store'

// 捕获店铺二维码入口的 ?sid=，供后续请求附带 X-Store-Code
captureStoreCodeFromUrl()

const app = createApp(App)
app.use(Slider);
app.use(Icon);
app.use(Swipe);
app.use(SwipeItem);
app.use(Col);
app.use(Row);
app.use(Loading);
app.use(router)
app.mount('#app')

